<template>
  <div class="mb-5 container-fluid">
    <div class="report-icons">
      <a v-if="showValidate" @click="$emit('validate')" class="validate-icon" title="Validate report">
        <font-awesome-icon icon="check-circle" />
      </a>
      <a @click="createPdf" class="pdf-icon">
        <img src="@/assets/images/pdf.png" alt="PDF" height="32" />
      </a>
    </div>
    <div className="xz-report">
      <ZReportHeader :location="location" :company="company" :terminal="terminal" :zReport="zReport" />
      <ZReportTotalSales :zReport="zReport" :vat="vat" />
      <ZReportCategories :zReport="zReport" :vat="vat" />
      <ZReportSalesPayments :zReport="zReport" :vat="vat" />
      <ZReportRefund :zReport="zReport" :vat="vat" />

      <div v-if="terminal.terminalType == 'POS'">
          <ZReportVariousCounters :zReport="zReport"/>
          <!-- ZReportDiff v-if="zReport.diff != 0" :zReport="zReport" / -->
      </div>
    </div>
  </div>
</template>

<script>
  import ZReportHeader from "@/components/report/zreport/ZReportHeader";
  import ZReportTotalSales from "@/components/report/zreport/ZReportTotalSales";
  import ZReportCategories from "@/components/report/zreport/ZReportCategories";
  import ZReportSalesPayments from "@/components/report/zreport/ZReportSalesPayments";
  import ZReportRefund from "@/components/report/zreport/ZReportRefund";
  import ZReportVariousCounters from "@/components/report/zreport/ZReportVariousCounters";
  import ReportPdfBuilder from "@/util/ReportPdfBuilder";

  export default {
    components: {ZReportHeader, ZReportTotalSales, ZReportCategories, ZReportSalesPayments, ZReportRefund, ZReportVariousCounters},
    props: {
      location: Object,
      terminal: Object,
      zReport: Object,
      company: Object,
      vat: Object,
      showValidate: { type: Boolean, default: false }
    },
    emits: ['validate'],
    methods: {
      createPdf() {
        ReportPdfBuilder.buildZReportPdf(this.zReport, this.location, this.terminal, this.vat);
      }
    }
  }
</script>

<style scoped>
.report-icons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 40px;
}
.report-icons .pdf-icon {
  margin-top: 0;
  display: inline;
}
.validate-icon {
  cursor: pointer;
  font-size: 28px;
  color: var(--bo-ink);
}
.validate-icon:hover {
  color: #0d6efd;
}
</style>
